<template>
  <div class="card-body">
    <div class="row mb-2">
      <div class="col-sm-8"></div>
    </div>
    <div class="row">
      <div class="col-sm-4"></div>
      <div class="col-md-4 text-right">
        <div class="form-row form-group">
          <div class="col-md-12">
            <div class="row">
              <!-- <div class="col-md-4 text-right"></div> -->
              <div class="col-md-12 text-center">
                <h5 style="color: red">
                  <label style="margin-right: 1rem; color: gray">พิมพ์คำว่า</label>  
                  "{{ textComfirm }}"  
                  <label style="margin-left: 1rem; color: gray">เพื่อยืนยัน</label>
                </h5>
              </div>
               <!-- <div class="col-md-4 text-left"></div> -->
            </div>
          </div>
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <input
              v-model="text"
              type="text"
              class="form-control"
            />
          </div>
          <div class="col-md-3"></div>
        </div>
      </div>
      <div class="col-sm-4"></div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-sm-center">
        <div class="button-items">
          <button
            :disabled="!isComfirm"
            @click="onBeforeSave()"
            type="button"
            class="btn btn-danger text-left"
          >
            <i class="bx bx-save" />Delete All
          </button>
          <button
            type="button"
            class="btn btn-light text-right"
            @click="onClear()"
          >
            Back
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import productService from '@/helpers/service/product-service'
import catalogService from '@/helpers/service/catalog-service'
import productCatalogService from '@/helpers/service/product-catalog-service'
import XLSX from 'xlsx'
import moment from 'moment'
import { Workbook } from 'exceljs'
import * as fs from 'file-saver'
import { ExportFileName } from '@/helpers/utils/format-date.js'
import { eventBus } from '@/main.js'

export default {
  props: {
    catalogIdSelected: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      textComfirm: 'DELETE',
      text: ''
    }
  },
  computed: {
    isComfirm() {
      return this.textComfirm === this.text
    }
  },
  watch: {
    
  },
  mounted: function() {
    
  },
  methods: {
    async onDeleteAllProductCatalog() {
      let result = await productCatalogService.deleteProductAllCatalogAsync(
        this.catalogIdSelected
      )
      if (result.status && result.status === 200) {
        this.isLoadProduct = false
        if (this.modeData === 'Delete') {
          this.$utils.notification('success', 'ลบข้อมูลทั้งหมดสำเร็จ', 1500)
          this.$emit('onSave', null)
        } else {
          this.$utils.notification('success', 'แก้ไขข้อมูลทั้งหมดสำเร็จ', 1500)
          this.$emit('onSave', this.productItems)
        }
        
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
        this.$emit('onSave', null)
      } else {
        this.$utils.notification('error', "เกิดข้อผิดพลาด", 2000)
        this.$emit('onSave', null)
      }
      this.onClear()
    },
    async onBeforeSave() {
      if (this.textComfirm !== this.text) return
      await this.$utils
                .confirmAlertDisplay(
                  `ต้องการลบข้อมูลทั้งหมดใช่หรือไม่`,
                  ''
                ).then(async result => {
                  if (result) await this.onDeleteAllProductCatalog()
                })
    },
    onClear() {
      this.text = ''
      this.$emit('onSave', null)
    },
  },
}
</script>
